export default {
  title: 'Umowa',
  description: 'Zostanie naliczona opłata {{amount}} miesięcznie, jeśli nie anulujesz okresu próbnego.',
  bill_at_launch_date: 'Pierwsza faktura w dniu uruchomienia',
  bill_date: 'Data rozliczenia: {{date}}',
  bill_date_after_launch: 'Data pierwszej faktury: {{days}} dni po uruchomieniu',
  sign_agreement: 'Podpisz umowę abonamentową i umowę uczestnictwa restauracji',
  restaurant: 'Restauracja',
  agreement:
    'Zgadzam się z <a href="{{terms_url}}" target="_blank" rel="noreferrer noopener">warunkami platformy</a>. Mogę anulować subskrypcję w dowolnym momencie, powiadamiając {{provider}} o anulowaniu. Subskrypcja zostanie anulowana, a umowa płatności odwołana, gdy tylko Restauracja skontaktuje się z {{provider}} w sprawie anulowania e-mailem lub przez WhatsApp. Restauracja nie będzie już obciążana żadnymi dalszymi opłatami. Zgadzam się, że moja elektroniczna zgoda jest równoznaczna z podpisaniem tego dokumentu, i rozumiem, że mój podpis elektroniczny jest wiążący.',
};
